import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-tryangle_right",
  "use": "vab-icon-tryangle_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-tryangle_right\">\r\n<path d=\"M13.7683 11.4633C14.0772 11.7597 14.0772 12.2403 13.7683 12.5367L9.35024 16.7762C8.85197 17.2543 8 16.9157 8 16.2395L8 7.7605C8 7.08432 8.85197 6.74569 9.35024 7.22382L13.7683 11.4633Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol